import RouterUtility from 'utils/routerUtility';
import { CLIENT_TYPE } from '../constants/auth/clientType';
var configPromise = require("../config").configPromise;
var Api = require("./api");

var TOKEN_URL = "/Token",
  LOGOUT_URL = "/api/account/logout",
  LOGOUT_ACT_AS_URL = "/api/account/endActAs";

var GRANT_TYPE_ACT_AS = "user_actAs",
  GRANT_TYPE_EXTERNAL = "user_session",
  GRANT_TYPE_PASSWORD = "password";

/**
 * Authentication api
 * @type {{signIn: AuthenticationApi.signIn}}
 */
var AuthenticationApi = {

  async requestToken(data) {
    const config = await configPromise;
    const token = await Api.postUrlEncoded(config.apiPath(TOKEN_URL), data);
    return token;
  },

  /**
   * Sign in
   * POST /Token
   * @param data account data
   * @returns {*} token data
   */
  signIn(data) {
    const tokenData = {
      grant_type: GRANT_TYPE_PASSWORD,
      username: data.email,
      password: data.password,
      client_id: CLIENT_TYPE.WEB
    };
    return this.requestToken(tokenData);
  },

  /**
   * Sing in external
   * @param data
   * @returns {*}
   */
  signInSso(data) {
    const tokenData = {
      grant_type: GRANT_TYPE_EXTERNAL,
      sessionid: data.sessionId,
      external_token: data.token,
      client_id: CLIENT_TYPE.WEB
    };
    return this.requestToken(tokenData);
  },

  /**
   * Sign in using _2bap_external_token token
   * @param data
   */
  signIn2BapExternal: function (data) {
    const tokenData = {
      grant_type: GRANT_TYPE_EXTERNAL,
      client_id: CLIENT_TYPE.WEB_VIEW,
      _2bap_external_token: data._2bap_external_token
    };
    return this.requestToken(tokenData);
  },

  /**
   * Sign in "Act as"
   * @param data impersonate user data
   */
  signInActAs: function (data) {
    const tokenData = {
      grant_type: GRANT_TYPE_ACT_AS,
      sessionid: data.sessionId,
      client_id: CLIENT_TYPE.WEB
    };
    return this.requestToken(tokenData);
  },

  /**
   * Log out
   * @param {LogoutModel} model
   * @returns {*}
   */
  logout: function (model) {
    return configPromise
      .then(function (config) {
        var url = config.apiPath(LOGOUT_URL);

        return Api.post(url, model);
      })
      .catch(function (error) {
        throw error;
      });
    ;
  },

  /**
   * Log out "Act as" mode
   * @returns {*}
   */
  logoutActAs: function () {
    return configPromise
      .then(function (config) {
        var url = config.apiPath(LOGOUT_ACT_AS_URL);

        return Api.post(url);
      })
      .catch(function (error) {
        throw error;
      });
    ;
  }
};

module.exports = AuthenticationApi;

